import React from 'react'

import Routing from './Components/Routes/Routing'

const App = () => {

  return (
    <>
      <Routing />
    </>
  )
}

export default App
